import styled, { css } from 'styled-components'
import { TextButton, Card, isMobileStyleMixin as isMobile } from '@amzn/storm-ui'
import Skeleton from 'react-loading-skeleton'
import { PartnerPrimaryContactButton } from 'shared/components/contact_action_buttons/contact_action_button'

export const StyledPartnerComparisonCard = styled(Card)`
  display: flex;
  flex-grow: 1;
  min-height: 480px;
  min-width: 282px;
  :first-child {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
    margin-inline-start: ${({ theme }) => theme.spacing.micro};
  }
  :last-child {
    border-end-start-radius: 0;
    border-start-start-radius: 0;
  }
  :nth-child(2) {
    border-radius: 0;
  }
`
export const ComparisonPartnerCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacing.medium} ${theme.spacing.medium} 0`};
`
export const ComparisonPartnerCardBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => `0 ${theme.spacing.medium} ${theme.spacing.medium}`};
`

export const PartnerRemoveButton = styled(TextButton)`
  margin-top: ${({ theme }) => theme.spacing.small};
  :hover {
    text-decoration: none;
  }
  ${isMobile(css`
    margin: ${({ theme }) => theme.spacing.large} 0;
  `)}
`

export const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const MobileBadgeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${({ theme }) => theme.spacing.small};
`
export const MobileContactButton = styled(PartnerPrimaryContactButton)`
  margin-top: ${({ theme }) => theme.spacing.base};
`

export const StyledSkeleton = styled(Skeleton)`
  margin-bottom: ${({ theme }) => theme.spacing.base};
`
